import get from 'lodash/get'

import {
  fetchCollection,
  performActionOnResource
} from './index'

import { qaTaskSchema } from '../schemas'

export const QA_TASKS_REQUEST = 'QA_TASKS_REQUEST'
export const QA_TASKS_SUCCESS = 'QA_TASKS_SUCCESS'
export const QA_TASKS_FAILURE = 'QA_TASKS_FAILURE'

export function fetchQATasksForServicing (url, qaServicingId, reload) {
  return fetchCollection({
    url,
    key: 'qaTasks',
    schema: qaTaskSchema,
    actions: [ QA_TASKS_REQUEST, QA_TASKS_SUCCESS, QA_TASKS_FAILURE ],
    responseInterceptor: response => ({ ...response, qaServicingId, reload })
  })
}

export function loadQATasksForServicing (qaServicingId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.qaTasksByQaServicing.${qaServicingId}`, {})

    if (!nextPage) {
      nextPageUrl = `/qa_servicings/${qaServicingId}/qa_tasks`
    }

    return dispatch(fetchQATasksForServicing(nextPageUrl, qaServicingId, !nextPage))
  }
}

export const MARK_QA_TASK_COMPLETE_REQUEST = 'MARK_QA_TASK_COMPLETE_REQUEST'
export const MARK_QA_TASK_COMPLETE_SUCCESS = 'MARK_QA_TASK_COMPLETE_SUCCESS'
export const MARK_QA_TASK_COMPLETE_FAILURE = 'MARK_QA_TASK_COMPLETE_FAILURE'

export function markQATaskComplete (qaTaskId) {
  return performActionOnResource({
    url: `/qa_tasks/${qaTaskId}`,
    action: 'complete',
    key: 'qaTask',
    schema: qaTaskSchema,
    actions: [ MARK_QA_TASK_COMPLETE_REQUEST, MARK_QA_TASK_COMPLETE_SUCCESS, MARK_QA_TASK_COMPLETE_FAILURE ]
  })
}

export const MARK_QA_TASK_UNABLE_REQUEST = 'MARK_QA_TASK_UNABLE_REQUEST'
export const MARK_QA_TASK_UNABLE_SUCCESS = 'MARK_QA_TASK_UNABLE_SUCCESS'
export const MARK_QA_TASK_UNABLE_FAILURE = 'MARK_QA_TASK_UNABLE_FAILURE'

export function markQATaskUnable (qaTaskId) {
  return performActionOnResource({
    url: `/qa_tasks/${qaTaskId}`,
    action: 'mark_as_unable',
    key: 'qaTask',
    schema: qaTaskSchema,
    actions: [ MARK_QA_TASK_UNABLE_REQUEST, MARK_QA_TASK_UNABLE_SUCCESS, MARK_QA_TASK_UNABLE_FAILURE ]
  })
}



// WEBPACK FOOTER //
// ./src/actions/qa-tasks.js